// Vendor Libs
import { toLower } from 'lodash';
import { REHYDRATE } from 'redux-persist';

const initialState = {
  error: null,
  fetched: false,
  fetching: false,
  matureStores: {},
  stores: {},
  user: null,
};

const actions = {
  PREFERENCES_FETCH: (state) => ({
    ...state,
    error: null,
    fetched: false,
    fetching: true,
  }),

  PREFERENCES_FETCH_FULFILLED: (state) => ({
    ...state,
    error: null,
    fetched: true,
    fetching: false,
  }),

  PREFERENCES_FETCH_REJECTED: (state, { error }) => ({
    ...state,
    error,
    fetched: true,
    fetching: false,
  }),

  PREFERENCES_INIT: (state) => ({
    ...state,
    error: null,
  }),

  PREFERENCES_LOAD: (state, { matureStores, stores, user }) => ({
    ...state,
    fetched: true,
    fetching: false,
    matureStores,
    stores,
    user,
  }),

  PREFERENCES_RESET: () => ({ ...initialState }),

  PREFERENCES_SAVE: (state, { matureStores, stores, user }) => ({
    ...state,
    error: null,
    fetched: true,
    fetching: false,
    matureStores,
    stores,
    user,
  }),

  [REHYDRATE]: (state, { payload }) => {
    // Safely access preferences and user from payload using optional chaining
    const preferencesData = payload?.preferences;
    const authUser = payload?.user;

    // Check conditions only if preferencesData and authUser are defined
    const shouldUpdate =
      preferencesData &&
      authUser &&
      preferencesData.user &&
      toLower(preferencesData.user) === toLower(authUser) &&
      !preferencesData.fetching;

    if (shouldUpdate) {
      // Merge state with preferencesData and update flags
      const updatedState = {
        ...state,
        ...preferencesData,
        error: null,
        fetched: false,
        fetching: false,
      };

      // Filter out empty matureStores
      if (
        updatedState.matureStores &&
        typeof updatedState.matureStores === 'object' &&
        Object.keys(updatedState.matureStores).length === 0
      ) {
        delete updatedState.matureStores;
      }

      // Filter out empty stores
      if (
        updatedState.stores &&
        typeof updatedState.stores === 'object' &&
        Object.keys(updatedState.stores).length === 0
      ) {
        delete updatedState.stores;
      }

      return updatedState;
    }
    return state;
  },
};

const reducer = (state = initialState, action) =>
  actions[action.type] ? actions[action.type](state, action) : state;

export default reducer;
